import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { FlashMessagesService } from '@mobilestar/ngx-flash-messages';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  // Login form object
  @ViewChild('loginForm', { static: true }) form: NgForm;

  // Login form binded data
  loginUser = {
    email: '',
    password: ''
  }

  // Booleans for enable and disable login button
  isLoginProgress: boolean = false;
  isFormValid: boolean = false;

  authSubscription: Subscription = null;

  verification = {
    open: false,
    progress: false,
    code: null
  };

  token: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private translateService: TranslateService,
    private flashMessages: FlashMessagesService
  ) { }

  ngOnInit() {
    // Navigate main if user already authenticated
    this.authSubscription = this.authService.getAuth().subscribe(auth => {
      if (auth) {
        if (environment.onlyDownloads) {
          this.router.navigate(['/whitelabels']);
        } else {
          this.router.navigate(['/']);
        }
      }
    });

    // Listen for form status
    this.form.statusChanges.subscribe(result => {
      if (result == 'VALID') {
        this.isFormValid = true;
      } else {
        this.isFormValid = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) { this.authSubscription.unsubscribe() }
  }

  onLogin(form: NgForm) {
    if (!navigator.onLine) {
      this.translateService.get('APP.LOGIN.NO_INTERNET_ERROR').toPromise()
      .then(result => {
        this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      });
      
    } else {
      // Start login process if form valid
      // Form always valid. When form not valid -> Login button disabled
      this.isLoginProgress = true;

      this.verification.open = true;
      this.authService.login(form.value.email, form.value.password)
      .then(resp => {
        if (resp.vsight_result.status && resp.vsight_result.status === "verification-sended") {
          this.token = resp.firebase_result.idToken;
          this.isLoginProgress = false;
        } else {
          this.authService.loginToFirebase(resp.vsight_result.token)
          .finally(() => {
            this.isLoginProgress = false;
          });
        }
      })
      .catch(error => {
        this.isLoginProgress = false;
        this.showLoginError(error);
      });
    }
  }

  onVerify(verificationCode: string) {
    this.verification.progress = true;
    this.authService.verifyLoginCode(this.token, verificationCode)
    .then(result => this.authService.loginToFirebase(result.token))
    .catch(error => this.showLoginError(error))
    .finally(() => { this.verification.progress = false });
  }

  showLoginError(error: any) {
    if (error instanceof HttpErrorResponse) {
      if (error.error === 'wrong-username-password') {
        this.translateService.get('APP.LOGIN.USERNAME_PASSWORD_ERROR').toPromise().then(result => {
          this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
        });
      } else if (error.error === 'invalid-verification-code') {
        this.translateService.get('APP.LOGIN.INVALID_VERIFICATION_CODE').toPromise().then(result => {
          this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
        });
      } else if (error.error === 'too-many-attempts') {
        this.translateService.get('APP.LOGIN.TOO_MANY_ATTEMPTS').toPromise().then(result => {
          this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
        });
      } else {
        this.translateService.get('APP.LOGIN.UNKNOWN_ERROR').toPromise().then(result => {
          this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
        });
      }
    } else {
      this.translateService.get('APP.LOGIN.UNKNOWN_ERROR').toPromise().then(result => {
        this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      });
    }
  }

  onTermsofService() {
    window.open(window.location.origin+"/terms");
  }

  onPrivacyPolicy() {
    window.open(window.location.origin+"/privacy");
  }
}
